// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from ProductAttention.module.scss  */
.ProductAttention-module-Root_1wP {
  font-size: 16px;
  line-height: 22px;
  color: #f8a100;
  /* Accent/Orange */ }
  @media (max-width: 900px) {
    .ProductAttention-module-Root_1wP {
      font-size: 14px;
      line-height: 18px; } }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Product/Attention/ProductAttention.css"],"names":[],"mappings":"AAAA,iDAAiD;AACjD;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB,EAAE;EACpB;IACE;MACE,eAAe;MACf,iBAAiB,EAAE,EAAE","sourcesContent":["/*  imported from ProductAttention.module.scss  */\n.ProductAttention-module-Root_1wP {\n  font-size: 16px;\n  line-height: 22px;\n  color: #f8a100;\n  /* Accent/Orange */ }\n  @media (max-width: 900px) {\n    .ProductAttention-module-Root_1wP {\n      font-size: 14px;\n      line-height: 18px; } }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
